function TextIcon({ fill }: string | any | { fill: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={fill ? fill : "#2c2c2c"}
        d="M8.545 12a.91.91 0 100 1.818h7.273a.91.91 0 100-1.818H8.545zM7.636 16.546a.91.91 0 01.91-.91h7.272a.91.91 0 110 1.819H8.545a.91.91 0 01-.909-.91zM8.545 8.364a.91.91 0 000 1.818h1.819a.91.91 0 100-1.818H8.545z"
      ></path>
      <path
        fill={fill ? fill : "#2c2c2c"}
        fillRule="evenodd"
        d="M4.799 2.799A2.727 2.727 0 016.727 2H14a.91.91 0 01.643.266l5.454 5.455c.17.17.267.402.267.643v10.909A2.727 2.727 0 0117.636 22H6.727A2.727 2.727 0 014 19.273V4.727c0-.723.287-1.417.799-1.928zm1.928 1.02a.91.91 0 00-.909.908v14.546a.91.91 0 00.91.909h10.908a.91.91 0 00.91-.91v-10H14a.91.91 0 01-.91-.908V3.818H6.728zm8.182 1.285l2.35 2.35h-2.35v-2.35z"
        clipRule="evenodd"
      ></path>
      <path
        stroke={fill ? fill : "#2c2c2c"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.3"
        d="M8.545 12a.91.91 0 100 1.818h7.273a.91.91 0 100-1.818H8.545zM7.636 16.546a.91.91 0 01.91-.91h7.272a.91.91 0 110 1.819H8.545a.91.91 0 01-.909-.91zM8.545 8.364a.91.91 0 000 1.818h1.819a.91.91 0 100-1.818H8.545z"
      ></path>
      <path
        stroke={fill ? fill : "#2c2c2c"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.3"
        d="M4.799 2.799A2.727 2.727 0 016.727 2H14a.91.91 0 01.643.266l5.454 5.455c.17.17.267.402.267.643v10.909A2.727 2.727 0 0117.636 22H6.727A2.727 2.727 0 014 19.273V4.727c0-.723.287-1.417.799-1.928zm1.928 1.02a.91.91 0 00-.909.908v14.546a.91.91 0 00.91.909h10.908a.91.91 0 00.91-.91v-10H14a.91.91 0 01-.91-.908V3.818H6.728zm8.182 1.285l2.35 2.35h-2.35v-2.35z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export default TextIcon;
